import { Component } from '@angular/core';

@Component({
  selector: 'app-acquisitions',
  templateUrl: './acquisitions.component.html',
  styleUrls: ['./acquisitions.component.css']
})
export class AcquisitionsComponent {
  ngOnInit() {
    window.open("https://cam.fo.uiowa.edu/news/2023/11/iaccts-acquisitions-equipment-software-and-leases")
  }
}
